<template>
  <div class="login">
    <div class="login-bg"></div>
    <div class="login-page d-flex">
      <input
        class="d-none"
        type="checkbox"
        name=""
        id="login"
      />
      <LoginLogo></LoginLogo>
      <LoginForm></LoginForm>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/login/LoginForm';
import LoginLogo from '@/components/login/LoginLogo';

export default {
  components: {
    LoginForm,
    LoginLogo,
  },
};
</script>

<style lang="scss" scoped></style>
